import { basicCurrencyList,basicCurrencyListAll} from '@/api/basic/basicCurrency.js'
import { getProductAllList} from '@/api/basic/basicMaker.js'
const state = {
	openTab: [{ // 主页面
		name: '首页',
		title: '首页',
		route: '/welcome'
	}], //所有打开的路由
	activeIndex: '/welcome', //激活状态
	cachedViews: ['Home'], // 初始化缓存 每个页面的用于名字  keep-alive 标签
	size: window.localStorage.getItem("size") || 'medium', //设置页面字体 大小
	sizeInfo:{	// 页面size信息
		h:0,
		w:0
	},
	currencyInfo:{//货币种类信息
		list:[],
		obj:{}
	},
	makerInfo:{	//制造商信息
		list:[],
		obj:{}
	},
}

const unCachedViews = ['InquiryDetail'] //不缓存的页面 name

const getters = {
	cachedViews: state => state.cachedViews,
	openTab: state => state.openTab,
	size: state => state.size,
	sizeInfo: state => state.sizeInfo,
	currencyInfo: state => state.currencyInfo,
	makerInfo: state => state.makerInfo,
}
const mutations = { //同步方法
	// 添加tabs
	add_tabs(state, data) {
		state.openTab.push(data);
	},
	// 删除tabs
	delete_tabs(state, tabRoute) {
		let index = 0;
		//判断 name 名字是否相等，找到下标并删除
		for (let option of state.openTab) {
			if (option.route === tabRoute) {
				//找出缓存name的下标  然后 删除
				const i = state.cachedViews.indexOf(option.name);
				if (i != -1) {
					state.cachedViews.splice(i, 1);
				}
				break;
			}
			index++;
		}
		state.openTab.splice(index, 1);
	},
	add_cachedViews(state, name) {
		//根据name缓存页面信息
		if (unCachedViews.indexOf(name) == -1) {
			let flag = state.cachedViews.some(item => {
				return name == item
			})
			//已存在则不缓存
			if (!flag) {
				state.cachedViews.push(name);
			}
		}
	},
	delete_cachedViews(state, name) {
		//根据下标删除名字
		const i = state.cachedViews.indexOf(name);
		if (i != -1) {
			state.cachedViews.splice(i, 1);
		}
	},
	//关闭其他选项卡
	DEL_NOT_CURRENTTABS(state, index) {
		//filter根据条件重新组成新数组  除了当前下标的所有tab和 cachedViews 下标0 代表首页 不移除
		const cachedViews = state.cachedViews.filter(function(item, i) {
			return index == i || i == 0;
		});
		state.cachedViews = cachedViews;
		const openTab = state.openTab.filter(function(item, i) {
			return index == i || i == 0;
		});
		state.openTab = openTab;
	},
	// 设置当前激活的tab
	set_active_index(state, index) {
		state.activeIndex = index;
	},
	SET_SIZE: (state, size) => {
		state.size = size
		window.localStorage.setItem('size', size)
	},
	DEL_ALL_CACHED_VIEWS: state => {
		state.cachedViews = []
	},
	SET_SIZEINFO: (state, info) => {
		state.sizeInfo = info
	},
	SET_CURRENCY: (state, info) => {
		state.currencyInfo = info
	},
	SET_MAKER: (state, info) => {
		state.makerInfo = info
	},
}
const actions = {
	SetSize({
		commit
	}, size) {
		commit('SET_SIZE', size)
	},
	DelAllCachedViews({
		commit,
		state
	}) {
		return new Promise(resolve => {
			commit('DEL_ALL_CACHED_VIEWS')
			resolve([...state.cachedViews])
		})
	},

	delNotCurrentTabs({
		commit,
		state
	}, index) {
		return new Promise(resolve => {
			commit('DEL_NOT_CURRENTTABS', index)
			//加中 括号代表返回数组，不然 只会返回数组第一个 值
			resolve([...state.openTab]);
		});
	},
	setSizeInfo({ commit , state }, obj){
		commit('SET_SIZEINFO',obj)
	},
	setCurrencyInfo({ commit , state }, obj){
		commit('SET_CURRENCY',obj)
	},
	setMakerInfo({ commit , state }, obj){
		commit('SET_MAKER',obj)
	},
	GetCurrencyInfo({ commit }) {
		return new Promise((resolve, reject) => {
			// // 向后端请求路由数据
			// basicCurrencyList({
			// 	page: 1, //当前页码
			// 	limit: 300, //当前每页显示的数量
			// }).then(res => {
			// 	if (res.data.code === 0) {
			// 		resolve(res)
			// 	} else {
			// 		reject(res)
			// 	}
			// })
			basicCurrencyListAll().then(res => {
				if (res.data.code === 0) {
					resolve(res)
				} else {
					reject(res)
				}
			})
		})
	},
	GetMakerInfo({ commit }) {
		return new Promise((resolve, reject) => {
			// // 向后端请求路由数据
			// basicCurrencyList({
			// 	page: 1, //当前页码
			// 	limit: 300, //当前每页显示的数量
			// }).then(res => {
			// 	if (res.data.code === 0) {
			// 		resolve(res)
			// 	} else {
			// 		reject(res)
			// 	}
			// })
			getProductAllList().then(res => {
				if (res.data.code == 0) {
					resolve(res)
				} else {
					reject(res)
				}
			})
		})
	},
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
